class HomeController {
  constructor(
    $rootScope,
    $scope,
    $timeout,
    $interval,
    $stateParams,
    $sanitize,
    homeService,
    toastr,
    $compile,
    $location,
    $sce
  ) {
    'ngInject';
    this.name = 'home';
    this.$sce = $sce;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$stateParams = $stateParams;
    this.$timeout = $timeout;
    this.$interval = $interval;
    this.homeService = homeService;
    this.$sanitize = $sanitize;
    this.$compile = $compile;
    this.$location = $location;
    $rootScope.page = this.name;
    this.loading = true;
    this.content = null;
    this.contentArray = [];
    $rootScope.id = $stateParams.id;
    $rootScope.$broadcast('CHANGE_LOGO');

    // Identify Language
    if (
      this.$rootScope.language == undefined &&
      this.$stateParams.lang == null
    ) {
      this.$rootScope.language = 'de';
      $rootScope.$broadcast('GET_MENU');
    } else if (this.$rootScope.language == undefined) {
      this.$rootScope.language = this.$stateParams.lang;
      $rootScope.$broadcast('GET_MENU');
    }

    /**
     * Function to be called if the current page has a transition
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $scope.$on('$locationChangeSuccess', (event, data) => {
      $rootScope.id = $stateParams.id;
      $rootScope.$broadcast('CHANGE_LOGO');
      // Identify Language
      if (
        this.$rootScope.language == undefined &&
        this.$stateParams.lang == null
      ) {
        this.$rootScope.language = 'de';
        $rootScope.$broadcast('GET_MENU');
      } else if (this.$rootScope.language == undefined) {
        this.$rootScope.language = this.$stateParams.lang;
        $rootScope.$broadcast('GET_MENU');
      }
      // Reset Scrolling
      jQuery('.app').animate(
        {
          scrollTop: 0,
        },
        1000
      );
    });

    /**
     * Function to be called when the content gets saved
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $scope.$on('SAVE', (event, data) => {
      this.content = this.contentArray.join('<span class="pagebreak"></span>');
      this.homeService
        .setContent(this.$stateParams.id, this.content)
        .then((result) => {
          toastr.success('Die Seite wurde erfolgreich gespeichert.');
        });
    });

    /**
     * Function to be called when the content gets saved
     * @param  {string} $routeChangeStart     the event
     * @param  {object} event                 the event object
     * @return {void}
     */
    $scope.$on('CANCEL', (event, data) => {
      this.content = angular.copy(this.contentBackup);
      this.contentArray = this.content.split('<span class="pagebreak"></span>');
    });

    jQuery.fn.findNext = function(selector, steps, scope) {
      // Steps given? Then parse to int
      if (steps) {
        steps = Math.floor(steps);
      } else if (steps === 0) {
        // Stupid case :)
        return this;
      } else {
        // Else, try the easy way
        var next = this.next(selector);
        if (next.length) return next;
        // Easy way failed, try the hard way :)
        steps = 1;
      }

      // Set scope to document or user-defined
      scope = scope ? jQuery(scope) : jQuery(document);

      // Find kids that match selector: used as exclusion filter
      var kids = this.find(selector);

      // Find in parent(s)
      var hay = jQuery(this);
      while (hay[0] != scope[0]) {
        // Move up one level
        hay = hay.parent();
        // Select all kids of parent
        //  - excluding kids of current element (next != inside),
        //  - add current element (will be added in document order)
        var rs = hay
          .find(selector)
          .not(kids)
          .add(jQuery(this));
        // Move the desired number of steps
        var id = rs.index(this) + steps;
        // Result found? then return
        if (id > -1 && id < rs.length) return jQuery(rs[id]);
      }
      // Return empty result
      return jQuery([]);
    };

    this.getContent();
  }

  getContent() {

    this.homeService
      .getContent(this.$stateParams.id, this.$stateParams.lang)
      .then((result) => {
        this.content = this.$sanitize(result.data.text);
        this.contentBackup = angular.copy(this.content);

        if (result.data.editable == undefined) {
          this.$rootScope.editable = false;
        } else {
          this.$rootScope.editable = true;
        }
        // img replace workaround
        this.content = this.content
          .split('logo.php/')
          .join('https://www.eigenkapitalforum.com/logo.php/');
        this.contentArray = this.content.split(
          '<span class="pagebreak"></span>'
        );

        /*this.contentArray.forEach((content, index) => {
          // content = content.match(/(?:<iframe[^>]*)(?:(?:\/>)|(?:>.*?<\/iframe>))/g);
          const match = content.match(/(<img(.*class=['\"](.*)ta-insert-video(.*)['\"].*)*>)+/g);
          this.contentArray[index] = content.replace(/(<img(.*class=['\"](.*)ta-insert-video(.*)['\"].*)*>)+/g, '<button onclick="setIFrame(match)">Test</button>');
          console.log('MATCH', match);
        });*/

        if (this.$stateParams.id == 285 || this.$stateParams.id == 284) {
          this.galerie = [];
          // YouTube-Tags erkennen
          var youtubeMatches = this.contentArray[0].match(/\[youtube\s+id=(?:&#34;|&quot;|["\u201C\u201D\u201E])([^"&#\u201C\u201D\u201E]*)(?:&#34;|&quot;|["\u201C\u201D\u201E])\]/g);
          if (youtubeMatches) {
            angular.forEach(youtubeMatches, (match) => {
              var id = match.match(/id=(?:&#34;|&quot;|["\u201C\u201D\u201E])([^"&#\u201C\u201D\u201E]*)(?:&#34;|&quot;|["\u201C\u201D\u201E])/)[1];
              this.galerie.push('youtube:' + id);
            });
          }
          // Bilder extrahieren
          this.images = this.contentArray[0].match(/src="([^"]*)"/g);
          if (this.images) {
            angular.forEach(this.images, (value, key) => {
              value = value.replace('src="', '').replace('"', '');
              this.galerie.push(value);
            });
          }
        }

        const sponsorTypeOrder = [41, 42, 43, 45, 44]; // Platinum, Gold, Silver, Supporter, Media

        // Sponsor ticker on landing page
        if (!this.$stateParams.id) {
          this.sponsorTickerGroups = [];
          this.homeService.getSponsorTypes(this.$rootScope.language).then((types) => {
            this.homeService.getSponsors(this.$rootScope.language).then((sponsors) => {
              if (types && sponsors) {
                var orderedTypes = sponsorTypeOrder.map(function(typeId) {
                  return types.find(function(type) { return type.id == typeId; });
                }).filter(function(type) { return !!type; });
                angular.forEach(orderedTypes, (type) => {
                  var group = {
                    name: type.name,
                    sponsors: sponsors.filter(function(s) { return s.sponsor_type == type.id && s.show_in_frontend == 1; })
                  };
                  if (group.sponsors.length > 0) {
                    // Basis-Set fuellt mindestens die Containerbreite (~200px/Logo, ~4000px Reserve)
                    var minItems = Math.ceil(4000 / (200 * group.sponsors.length));
                    if (minItems < 2) minItems = 2;
                    var baseSet = [];
                    for (var r = 0; r < minItems; r++) {
                      baseSet = baseSet.concat(group.sponsors);
                    }
                    // exakt verdoppeln -> translateX(-50%) ergibt einen nahtlosen CSS-Loop
                    group.sponsorsRepeated = baseSet.concat(baseSet);
                    this.sponsorTickerGroups.push(group);
                  }
                });
                // Konstante Scroll-Geschwindigkeit per requestAnimationFrame:
                // Bewegung = feste px/s ueber delta-time. Die Geschwindigkeit haengt damit NICHT
                // mehr von einer Breitenmessung ab -> unabhaengig von Bild-Ladezeit/Cache/Logo-Breite.
                // scrollWidth wird nur fuer den Loop-Reset gebraucht und korrigiert sich selbst.
                this.$timeout(() => {
                  var SPEED = 100; // px pro Sekunde -> hier Tempo justieren
                  var reduce = window.matchMedia &&
                    window.matchMedia('(prefers-reduced-motion: reduce)').matches;
                  var tracks = [];
                  jQuery('.sponsor-marquee__track').each(function() {
                    if (reduce) return; // Barrierefreiheit: keine Bewegung
                    var track = this;
                    var wrap = track.parentNode; // .sponsor-marquee
                    var s = { id: null, offset: 0, last: null, paused: false, half: 0, since: 1 };
                    tracks.push(s);
                    track.style.willChange = 'transform';
                    jQuery(wrap).on('mouseenter', function() { s.paused = true; })
                                .on('mouseleave', function() { s.paused = false; });
                    var frame = function(now) {
                      if (s.last === null) s.last = now;
                      var dt = (now - s.last) / 1000;
                      s.last = now;
                      if (dt > 0.05) dt = 0.05; // clampen -> kein Sprung nach Tab-Wechsel/Idle
                      // Loop-Distanz gelegentlich neu messen (kein Per-Frame-Reflow);
                      // solange die Bilder noch laden, waechst half und korrigiert sich selbst.
                      s.since += dt;
                      if (s.half <= 0 || s.since > 0.5) { s.half = track.scrollWidth / 2; s.since = 0; }
                      if (!s.paused && s.half > 0) {
                        s.offset += SPEED * dt;
                        if (s.offset >= s.half) s.offset -= s.half; // nahtloser Wrap
                        track.style.transform = 'translateX(' + (-s.offset) + 'px)';
                      }
                      s.id = window.requestAnimationFrame(frame);
                    };
                    s.id = window.requestAnimationFrame(frame);
                  });
                  // Cleanup bei SPA-Navigation -> verhindert weiterlaufende Loops (Leak)
                  this.$scope.$on('$destroy', function() {
                    tracks.forEach(function(s) { if (s.id) window.cancelAnimationFrame(s.id); });
                  });
                }, 0);
              }
            });
          });
        }

        if (this.$stateParams.id == 225 || this.$stateParams.id == 253) {
          this.sponsorGroups = [];
          var lang = this.$stateParams.id == 225 ? 'de' : 'en';
          this.homeService.getSponsorTypes(lang).then((types) => {
            this.homeService.getSponsors(lang).then((sponsors) => {
              if (types && sponsors) {
                var orderedTypes = sponsorTypeOrder.map(function(typeId) {
                  return types.find(function(type) { return type.id == typeId; });
                }).filter(function(type) { return !!type; });
                angular.forEach(orderedTypes, (type) => {
                  var group = {
                    name: type.name,
                    sponsors: sponsors.filter(function(s) { return s.sponsor_type == type.id && s.sponsor_profile_visible == 1; })
                  };
                  if (group.sponsors.length > 0) {
                    this.sponsorGroups.push(group);
                  }
                });
              }
            });
          });
        }

        if (this.$stateParams.id == 150 || this.$stateParams.id == 168) {
          this.faqs = [];
          this.contentArray[0] = this.contentArray[0].replace(
            /href="([^"]*)"/g,
            'ng-click="vm.scrollMeTo(\'$1\')"'
          );
          this.contentArray[0] = this.contentArray[0].replace(/#FAQ/g, '.FAQ');
        }

        this.$timeout(() => {
          this.loading = false;
          var that = this;
          this.$timeout(() => {
            jQuery('#pres_dl').bind('click', (event) => {
              jQuery('a.k-button.k-button-icontext.k-grid-pdf').click();
              jQuery('#pres_dl').html(
                jQuery('#pres_dl').html() +
                  '<span style="display: block; position: relative;" class="loader-container-inner" id="loader_pres"><span class="loader"><span class="loader-inner"></span></span></span>'
              );

              setTimeout(() => {
                jQuery('#loader_pres').remove();
              }, 4000);
            });
            jQuery('.content-cube').each(function() {
              if (!that.$stateParams.id == 225 && !that.$stateParams.id == 253) {
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('.content-cube-html')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('img')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('div')
                    .children('.content-cube-html')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('div')
                    .children('div')
                    .children('.content-cube-html')
                    .height() + 70
                );
              }
            });

            jQuery('.showNextDiv').each(function() {
              jQuery(this).bind('click', function() {
                if (
                  jQuery(this)
                    .findNext('.hiddenText')
                    .hasClass('displayNone')
                ) {
                  jQuery(this)
                    .findNext('.hiddenText')
                    .removeClass('displayNone');
                } else {
                  jQuery(this)
                    .findNext('.hiddenText')
                    .addClass('displayNone');
                }
              });
            });

            // Workaround
            setInterval(function() {
              jQuery('.content-cube').each(function() {
                //if (!that.$stateParams.id == 220 && !that.$stateParams.id == 253) {
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('.content-cube-html')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('img')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('div')
                    .children('.content-cube-html')
                    .height() + 70
                );
                jQuery(this).css(
                  'height',
                  jQuery(this)
                    .children('div')
                    .children('div')
                    .children('.content-cube-html')
                    .height() + 70
                );
                if (jQuery(window).width() < 1281) {
                  jQuery(this).css(
                    'height',
                    jQuery(this)
                      .children('div')
                      .children('.content-cube-html')
                      .height() *
                      2 +
                      100
                  );
                }
                //}
              });
            }, 1000);
            jQuery('.container').css(
              'height',
              jQuery('.container')
                .find('.homeContainer')
                .height()
            );
          }, 0);
        }, 0);
      });
  }

  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }

  scrollMeTo(hash) {
    this.$rootScope.autoScroll = hash;
  }

  showPrev() {
    var element = angular.element(jQuery('.carousel .left'));
    element.scope().prev();
  }

  showNext() {
    var element = angular.element(jQuery('.carousel .right'));
    element.scope().next();
  }

  getYoutubeUrl(image) {
    var videoId = image.replace('youtube:', '');
    return this.$sce.trustAsResourceUrl('https://www.youtube.com/embed/' + videoId);
  }
}

export default HomeController;



// WEBPACK FOOTER //
// ./client/app/components/home/home.controller.js